import axios from './axiosService';
import { UserSignUpRequestDto, UserSignUpResponseDto } from '../models';
import { RootService } from './rootService';
import { logger } from '../utils';

/**
 * Сервис, отвечающий за авторизацию пользователя.
 */
export class RegistrationService {
    /**
     * Корневой Web Api сервис.
     */
    rootService: RootService;

    /**
     * Конструктор.
     * @param rootService корневой Web Api сервис.
     */
    constructor(rootService: RootService) {
        this.rootService = rootService;
    }

    /**
     * Регистрация пользователя.
     * @param body тело запроса.
     */
    public async signUp(body: UserSignUpRequestDto): Promise<UserSignUpResponseDto> {
        try {
            const response = await axios.post<UserSignUpResponseDto>('registration/user/sign_up', body);

            return response.data;
        } catch (error: any) {
            logger.error(error);
            return Promise.reject(error);
        }
    }
}
